

import Skeleton from 'react-loading-skeleton';
import PropTypes from 'prop-types';
import { useMemo } from 'react';

const loaderVariants = [
    () => (
        <div className="senderMessage mb-3 px-4">
            <div className="flex items-center mb-1">
                <Skeleton circle height={40} width={40} />
                <div className="msg_info !mt-0 ">
                    <div className="sender_info">
                        <div className='mt-1.5'>
                            <Skeleton height={16} width={180} borderRadius={4} />
                            <div className="flex -mt-1">
                                <Skeleton height={12} width={100} borderRadius={4} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="msg_body_text group mb-1">
                <Skeleton height={24} width={200} borderRadius={4} />
                <div className='mt-1'>
                    <Skeleton height={24} width={300} borderRadius={4} />
                </div>
            </div>
        </div>
    ),
    () => (
        <div className="senderMessage mb-3 px-4">
            <div className="flex items-center mb-2">
                <Skeleton circle height={40} width={40} />
                <div className="msg_info !mt-0 ">
                    <div className="sender_info">
                        <div className='mt-1.5'>
                            <Skeleton height={16} width={180} borderRadius={4} />
                            <div className="flex -mt-1">
                                <Skeleton height={12} width={100} borderRadius={4} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="msg_body_text group mb-2">
                <Skeleton height={24} width={200} borderRadius={4} />
                <div className='mt-1'>
                    <Skeleton height={70} width={"100%"} borderRadius={4} />
                </div>
            </div>
        </div>
    ),
    () => (
        <div className="senderMessage mb-3 px-4">
            <div className="flex items-center mb-2">
                <Skeleton circle height={40} width={40} />
                <div className="msg_info !mt-0 ">
                    <div className="sender_info">
                        <div className='mt-1.5'>
                            <Skeleton height={16} width={180} borderRadius={4} />
                            <div className="flex -mt-1">
                                <Skeleton height={12} width={100} borderRadius={4} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="msg_body_text group mb-2">
                <Skeleton height={24} width={150} borderRadius={4} />
                <div className='mt-1'>
                    <Skeleton height={24} width={300} borderRadius={4} />
                </div>
                <div className='mt-1'>
                    <Skeleton height={24} width={250} borderRadius={4} />
                </div>
            </div>
        </div>
    ),
    () => (
        <div className="senderMessage mb-3 px-4">
            <div className="flex items-center mb-2">
                <Skeleton circle height={40} width={40} />
                <div className="msg_info !mt-0 ">
                    <div className="sender_info">
                        <div className='mt-1.5'>
                            <Skeleton height={16} width={180} borderRadius={4} />
                            <div className="flex -mt-1">
                                <Skeleton height={12} width={100} borderRadius={4} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="msg_body_text group mb-2">
                <Skeleton height={70} width={"100%"} borderRadius={4} />
            </div>
        </div>
    )
];

const MessageSkeleton = ({ counter = 5 }) => {
    // Memoize the random skeletons so they don't rerender unless counter changes
    const skeletons = useMemo(() => {
        return Array.from({ length: counter }).map((_, idx) => {
            const Variant = loaderVariants[Math.floor(Math.random() * loaderVariants.length)];
            return <Variant key={idx} />;
        });
    }, [counter]);

    return <div>{skeletons}</div>;
};

MessageSkeleton.propTypes = {
    counter: PropTypes.number
};

export default MessageSkeleton;